
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
})
export default class extends Vue {
  @Prop({ default: [] }) private data?: any
   private show = ''
   public infoWindowClose() {
     this.show = ''
   }
   public infoWindowOpen(position:any) {
     this.data && this.data.map((n:any) => {
       if (position.id === n.id) {
         n.infoWindowShowFlag = true
       } else {
         n.infoWindowShowFlag = false
       }
     })
     this.$forceUpdate()
   }
   created() {
     this.data && this.data.map((n:any) => {
       n.infoWindowShowFlag = false
     })
   }
}
